<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Apps
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
                <option value="9">Excluído</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="idc_possui_numero_viagens">Possui número de viagens <sup class="text-danger">* </sup></label>
              <select id="idc_possui_numero_viagens" v-model="registro.idc_possui_numero_viagens" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_possui_numero_viagens }">
                <option value="1">Sim</option>
                <option value="2">Não</option>
              </select>
              <span v-show="errors.idc_possui_numero_viagens != null" class="help-inline">{{ errors.idc_possui_numero_viagens }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_possui_segmentos">Possui segmentos <sup class="text-danger">* </sup></label>
              <select id="idc_possui_segmentos" v-model="registro.idc_possui_segmentos" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_possui_segmentos }">
                <option value="1">Sim</option>
                <option value="2">Não</option>
              </select>
              <span v-show="errors.idc_possui_segmentos != null" class="help-inline">{{ errors.idc_possui_segmentos }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="idc_usa_imagem">Usa imagens <sup class="text-danger">* </sup></label>
              <select id="idc_usa_imagem" v-model="registro.idc_usa_imagem" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_usa_imagem }">
                <option value="1">Sim</option>
                <option value="2">Não</option>
              </select>
              <span v-show="errors.idc_usa_imagem != null" class="help-inline">{{ errors.idc_usa_imagem }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AplicativoActions from '../../actions/AplicativoActions'

export default {
  name: 'novo',
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        descricao: '',
        idc_status: '',
        idc_possui_numero_viagens: '',
        idc_possui_segmentos: '',
        idc_usa_imagem: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Novo'
  },
  methods: {
    voltar () {
      this.$router.push('/aplicativos')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_possui_numero_viagens) {
        this.errors.idc_possui_numero_viagens = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_possui_segmentos) {
        this.errors.idc_possui_segmentos = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_usa_imagem) {
        this.errors.idc_usa_imagem = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        AplicativoActions.cadastrar({
          descricao: this.registro.descricao,
          idc_status: this.registro.idc_status,
          idc_possui_numero_viagens: this.registro.idc_possui_numero_viagens,
          idc_possui_segmentos: this.registro.idc_possui_segmentos,
          idc_usa_imagem: this.registro.idc_usa_imagem
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/aplicativos')
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/aplicativos/Novo.vue